class ProductOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => {
      this.querySelector(".product-form__option-selected-value").innerHTML =
        e.target.dataset.optionValue;
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("product-option")) {
  customElements.define("product-option", ProductOption);
}
